import React from 'react'

import { Button } from '@octane/spark'

interface Props {
    readonly applicationId: number
    readonly disabled?: boolean
    readonly blockerMessage?: string
}

export default function WorkTheDealButton({
    applicationId,
    disabled = false,
    blockerMessage,
}: Props): JSX.Element {
    if (disabled) {
        return (
            <>
                <Button
                    fullWidth
                    id="workTheDeal-button"
                    disabled
                    title={blockerMessage}
                >
                    Work the Deal
                </Button>
                {blockerMessage && (
                    <p className="text-danger mt-2 text-center">
                        {blockerMessage}
                    </p>
                )}
            </>
        )
    }

    return (
        <a
            href={`#/application/status/${applicationId}`}
            style={{ width: '100%' }}
        >
            <Button fullWidth id="workTheDeal-button">
                Work the Deal
            </Button>
        </a>
    )
}
